import { post, save, setCookie, getCookie, delCookie } from "./helper";
//appPersonController/getUnionAppActivityList
const userLogin = post("userLoginController/userLogin"); //登录
const getStaffPhoneSign = post("appPersonController/getStaffPhoneSign"); //获取验证码
const updatePassword = post("appPersonController/updatePassword");//修改密码
const updateStaffPhone = post("appPersonController/updateStaffPhone");//修改手机
const officeTreeData = post("hospitalOfficeController/officeTreeData");// 组织机构列表
const getAppStaffListData = post("appPersonController/getAppStaffListData"); //获取工会列表
const officeTransfer = post("hospitalStaffController/officeTransfer");//职工调度
const getAppWelfareList = post("appPersonController/getAppWelfareList");//福利列表
const getAppActivityList = post("appPersonController/getAppActivityList"); //我的活动列表
const activityListData = post("appPersonController/getUnionAppActivityList"); //活动列表
const getActivityPrizesList = post("appPersonController/getActivityPrizesList"); //活动福利
const getAppWelfareDetails = post("appPersonController/getAppWelfareDetails"); //获取福利详情
const signupWelfareSignature = save(
  "appPersonController/signupWelfareSignature"
); //保存签名

const getActivityPrizesForStaff = post(
  "appPersonController/getActivityPrizesForStaff"
); //5.13 获取职工的获奖内容详情（roleCode为空时，调用此接口）
const getActivityPrizesForUnion = post(
  "appPersonController/getActivityPrizesForUnion"
); //5.14 获取分会下的各奖项获奖人数统计（当roleCode为unionBranchAdmin，调用此接口）

const signupHonoreeSignature = save(
  "appPersonController/signupHonoreeSignature"
);//5.15 活动获奖人领奖签字（当roleCode为空时，调用此接口）

const unionBranchAdminSignature = save(
  "appPersonController/unionBranchAdminSignature"
);//5.16 分会主席对活动奖品进行确认（当roleCode为unionBranchAdmin，调用此接口）

const getActivityDetails = post("activityController/getActivityDetails"); //获取活动详情
const getActivityInfoAndSigninRecordByStaff = post(
  "appPersonController/getActivityInfoAndSigninRecordByStaff"
);//5.21 获取全员活动的领奖页面详情

// const saveAppSignIn = post(
//   "handhelDevicesController/saveAppSignIn"
// );//打卡



// const bindIBeaconForPunLoc = post(
//   "appPersonController/bindIBeaconForPunLoc"
// );//5.21 绑定打卡点信息接口

const getActivityInfoForSignup = post("activityController/getActivityInfoForSignup") //报名页活动详情
const saveSign = post("activityController/saveSignup"); //报名
const getStaffListForSignup  = post("appPersonController/getStaffListForSignup")//5.19 获取活动的报名人员名单
const getNewestList = post("appPersonController/getNewestList");//5.22 获取最新列表
const getGroupInfoForSignup = post("activityController/getGroupInfoForSignup"); //5.23 活动某组的报名详情
const delSignup = post("activityController/delSignup");//6.8 活动报名取消
const getWXInfo = post("weChat/getSignature"); //获取微信签名
const ibeaconVerify=post("ibeacon/verify"); //微信端验证ibeacon
const updateStaffWechat = post("weChat/updateStaffWechat");//8.3保存用户的唯一标示openId入库
const getUserInfoCache = post("userLoginController/getUserInfoCache")//根据sessionId获取用户信息
const userLogout = post("userLoginController/userLogout")//1.10 用户退出(移动端退出清空缓存信息)
const signinHonoreeSignature = save("appPersonController/signinHonoreeSignature")//5.20 全员活动会员领奖签名
const getSignGroup = post("activityController/getSignGroup");//5.24获取打卡分组信息
const getStaffDetails = post("hospitalStaffController/getStaffDetails");//2.14 获取会员详情


const getUserInformation = post("userLoginController/getUserInformation");//判断用户失效

const getComfortList = post("consolation/getComfortList");//慰问管理列表页面
const comfortApply = post("consolation/comfortApply");//慰问申请接口
const myComforts = post("consolation/myComforts");//我的慰问


// 按科室报名接口
const getBranchByDeptsLeader= post("activityController/getBranchByDeptsLeader");  
const signUpByDept= post("activityController/signUpByDept");  //分会主席按科室报名保存
const getInfoForDeptsLeader= post("activityController/getInfoForDeptsLeader"); 

//问卷所有接口
const getQuestionsData= post("activityController/getInfoForDeptsLeader"); 

//通知公告
const announcementVisiblePageList = post("announcement/announcementVisiblePageList");// 查询用户可见的公告列表
const announcementDetail= post("announcement/announcementDetail");// 查询公告详情
const announcementMarkAsRead= post("announcement/announcementMarkAsRead");// 查标记公告为已读
const announcementVisibleList = post("announcement/announcementVisibleList");// 查询用户未读公告数量
const getApprovalCountByUserId = post("consolation/getApprovalCountByUserId");// 查询职工权益申请配置


const addNewsPointBeforeRedirect = post("welfareController/addNewsPointBeforeRedirect");// 咨询跳转链接增加阅读量

const saveApprovalSign = post("hospitalUnionMemberController/saveApprovalSign")//微信端保存入会申请的签名
//提交电子签名
const addSignature = post("hospitalSignController/saveHospitalSignInfo")
    //获取签名
const getSignature = post("hospitalSignController/findHospitalSignList")

export {
  saveApprovalSign,
  addSignature,
  getSignature,
  // saveAppSignIn,
  // bindIBeaconForPunLoc,
  userLogin,
  getStaffPhoneSign,
  updatePassword,
  updateStaffPhone,
  officeTreeData,
  getAppStaffListData,
  officeTransfer,
  getAppWelfareList,
  getAppActivityList,
  activityListData,
  getActivityPrizesList,
  getAppWelfareDetails,
  signupWelfareSignature,
  getActivityPrizesForStaff,
  getActivityPrizesForUnion,
  signupHonoreeSignature,
  unionBranchAdminSignature,
  getActivityDetails,
  getActivityInfoAndSigninRecordByStaff,
  getActivityInfoForSignup,
  saveSign,
  getStaffListForSignup,
  getNewestList,
  getGroupInfoForSignup,
  delSignup,
  getWXInfo,
  updateStaffWechat,
  getUserInfoCache,
  userLogout,
  setCookie,
  getCookie,
  delCookie,
  signinHonoreeSignature,
  getSignGroup,
  getStaffDetails,
  getUserInformation,
  getComfortList,
  comfortApply,
  myComforts,
  ibeaconVerify,

  signUpByDept,
  getInfoForDeptsLeader,
  getBranchByDeptsLeader,
  getQuestionsData,
  //通知公告
  announcementVisiblePageList,
  announcementVisibleList,
  announcementDetail,
  announcementMarkAsRead,
  getApprovalCountByUserId,
  addNewsPointBeforeRedirect
};
